import { PasswordStrengthMeter } from "@/components/ui/password-input";

interface PasswordStrengthIndicatorProps {
  password?: string;
  shortScoreWord?: string;
  scoreWords?: string[];
}

const defaultScoreWords = ['schwach', 'schwach', 'okay', 'gut', 'stark'];

export const getPasswordStrengthScore = (password = ''): number => {
  if (!password) {
    return 0;
  }

  let score = 0;
  if (password.length >= 8) score += 1;
  if (/[a-z]/.test(password) && /[A-Z]/.test(password)) score += 1;
  if (/\d/.test(password)) score += 1;
  if (/[^A-Za-z0-9]/.test(password)) score += 1;
  if (password.length >= 12 && score < 4) score += 1;

  return Math.min(score, 4);
};

const PasswordStrengthIndicator = ({
  password = '',
  shortScoreWord = 'zu kurz',
  scoreWords = defaultScoreWords,
}: PasswordStrengthIndicatorProps) => {
  const score = getPasswordStrengthScore(password);
  const label = password.length > 0 && password.length < 6
    ? shortScoreWord
    : scoreWords[score] ?? defaultScoreWords[score];

  return (
    <PasswordStrengthMeter
      mt={1}
      value={score}
      max={4}
      label={label}
    />
  );
};

export default PasswordStrengthIndicator;
